import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getLocale } from '../../../../configuration';
import type { RootState } from '../../../../configuration/setup/store';
import { getDescriptionOfServiceUrl } from '../../config/productConfig';
import { getTenant, type Tenant } from '../utils/tenants';

interface Props {
    tenant: Tenant;
    serviceSku: string;
    level?: string;
    documentVersion?: string;
    show?: boolean;
    onClose?: () => void;
    locale: string;
    children?: React.ReactNode;
}

const DescriptionOfService = ({ serviceSku, level, documentVersion, locale, children, show, onClose }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const intl = useIntl();
    const dialogTitleId = 'intl-msg:marketplace.myServices.descriptionOfService.dialogTitle';
    const iframeTitle = intl.formatMessage({ id: dialogTitleId });
    const isShown = show ?? isOpen;
    const descriptionOfServiceUrl =
        documentVersion === undefined
            ? getDescriptionOfServiceUrl(locale, serviceSku, level)
            : getDescriptionOfServiceUrl(locale, serviceSku, level, documentVersion);

    return (
        <>
            <Dialog
                show={isShown}
                title={<FormattedMessage id={dialogTitleId} />}
                body={
                    <iframe
                        className='position-absolute top-0 left-0 width-100pct height-100pct'
                        src={descriptionOfServiceUrl}
                        title={iframeTitle}
                    />
                }
                onClose={() => {
                    setIsOpen(false);
                    onClose?.();
                }}
                footer={null}
                showCloseButton={true}
                bsSize={Dialog.SIZE_FULL_SCREEN}
            />
            {children && (
                <span
                    onClick={event => {
                        event.preventDefault();
                        setIsOpen(true);
                    }}
                >
                    {children}
                </span>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    tenant: getTenant(state),
    locale: getLocale(state),
});

export const DescriptionOfServiceContainer = connect(mapStateToProps)(DescriptionOfService);
